import React from "react"

import { Container, Row } from "reactstrap"

import CardsHeader from "components/Headers/CardsHeader.js"

class Dashboard extends React.Component {
  render() {
    return (
      <>
        <CardsHeader />
        <Container className="mt--6" fluid>
          <Row></Row>
        </Container>
      </>
    )
  }
}

export default Dashboard
